import m from "../../geodata/es2015/estoniaLow";
window.am4geodata_estoniaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/estoniaLow.js
// module id = null
// module chunks = 